import React from 'react';
import { CSSTransition } from 'react-transition-group';

import { isElementOfType, sanitizeFragments } from '../../utilities/components';

// Components
import { Portal } from '../portal/Portal';
import WpBackdrop from '../backdrop/WpBackdrop';
import { WpButton, WpButtonGroup } from '../button';
import WpIcon from '../icon/WpIcon';
import { WpText } from '../text';

import WpDrawerV2Body from './WpDrawerV2Body';
import WpDrawerV2Footer from './WpDrawerV2Footer';

// Styles
import './WpDrawerV2.scss';

type Props = {
  isOpen: boolean;
  withAnimation?: boolean;
  toggleIsOpen: () => void;
  title?: string | React.ReactNode;
  children?: React.ReactNode;
  actionButtons?: React.ReactNode;
  width?: number;
};

const WpDrawerV2 = ({ isOpen, withAnimation = true, toggleIsOpen, title, children, actionButtons, width }: Props) => {
  const hasTitleAsString = typeof title === 'string';
  const baseClassName = 'WpDrawerV2';

  const sanitizedChildren = children && sanitizeFragments(children);

  const content = (
    <div className={`${baseClassName}__content__wrapper`}>
      <div className={`${baseClassName}__content`} style={width && { width: `${width}px` }}>
        <div className={`${baseClassName}__content__header`}>
          {hasTitleAsString ? (
            <WpText bold noMargin>
              {title}
            </WpText>
          ) : (
            <div>{title}</div>
          )}
          <div className={`${baseClassName}__content__header__close-btn`}>
            <WpButtonGroup spacing="sm">
              {actionButtons}
              <WpButton size="sm" variant="tertiary" onClick={toggleIsOpen} square>
                <WpIcon name="times" />
              </WpButton>
            </WpButtonGroup>
          </div>
        </div>

        {/* <div className={`${baseClassName}__content__body`}>{children}</div> */}
        {React.Children.map(sanitizedChildren, (child: React.ReactElement<any>) => {
          if (child && isElementOfType(child, [WpDrawerV2Body, WpDrawerV2Footer])) {
            return React.cloneElement(child);
          }
          // return child;
        })}
      </div>
    </div>
  );

  return (
    <Portal idPrefix="drawer">
      <div className={baseClassName}>
        {withAnimation ? (
          <CSSTransition in={isOpen} timeout={350} classNames={`${baseClassName}__animation`} unmountOnExit>
            {content}
          </CSSTransition>
        ) : isOpen ? (
          <>{content}</>
        ) : null}
      </div>
      {isOpen && <WpBackdrop onClick={toggleIsOpen} />}
    </Portal>
  );
};

export default WpDrawerV2;
